/**
 * The type of the action which signals if the genericIFrame is visible or not.
 *
 * {
 *     type: SET_GENERICIFRAME_VISIBILITY_STATUS
 * }.
 */
export const SET_GENERICIFRAME_VISIBILITY_STATUS
    = 'SET_GENERICIFRAME_VISIBILITY_STATUS';

/**
 * The type of the action which updates the shared document URL.
 *
 * {
 *     type: SET_GENERICIFRAME_URL
 * }.
 */
export const SET_GENERICIFRAME_URL = 'SET_GENERICIFRAME_URL';

/**
 * The type of the action which signals to start or stop editing a shared
 * document.
 *
 * {
 *     type: TOGGLE_GENERICIFRAME_VISIBILITY
 * }.
 */
export const TOGGLE_GENERICIFRAME_VISIBILITY
    = 'TOGGLE_GENERICIFRAME_VISIBILITY';

/**
 * The type of the action which signals to start or stop editing a shared
 * document.
 *
 * {
 *     type: TOGGLE_GENERICIFRAME_VISIBILITY
 * }.
 */
export const TOGGLE_IFRAME_FOR_OTHERS = 'TOGGLE_IFRAME_FOR_OTHERS';

/**
 * The type of the action which signals to start or stop editing a shared
 * document.
 *
 * {
 *     type: TOGGLE_GENERICIFRAME_VISIBILITY
 * }.
 */
export const PARTICIPANT_WHITE_BOARD_ID = 'PARTICIPANT_WHITE_BOARD_ID';
